<div class="flex w-full items-center justify-center">
  <proffeo-ui-date-range-picker
    [(value)]="rangeValue"
    appearance="inline"
    endPlaceholder="task-filters.dateTo"
    startPlaceholder="task-filters.dateFrom"
  />
</div>
